import React from "react";
import "../App.css"
import footerimg from "../images/footer-img.png"
import logo from "../images/logo.png"
import discord from "../images/icon-discord.png"
import insta from "../images/icon-insta.png"
import twitter from "../images/icon-twitter.png"
import opensea from "../images/icon-opensea.png"

import JoinButton from "./JoinButton";

function Footer() {
    return (
        <div className="footerBg">
            <div className="container pb-5">
                <div className="row pt-5 mt-5 pb-5 mb-5">
                    <div className="col-md-6">
                        <h3 className="joinus">Join our community today and become a part of Project Artaxia</h3>
                        <div className="btn121 pt-5">
                            <JoinButton
                                text="Join Our Community"
                            />
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                    <div className="col-md-4">
                        <img className="w-100 footerImg" src={footerimg}></img>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <img className="" src={logo}></img>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <div className="footer-nav pt-5">
                            <ul className="footer-nav-link">
                                <a href="/">
                                    <p>Home</p>
                                </a>
                                <a href="#about">
                                    <p>About</p>
                                </a>
                                <a href="#promise">
                                    <p>Promises</p>
                                </a>
                                <a href="#team">
                                    <p>Team</p>
                                </a>
                                {/* <a href="#faq">
                                    <p>Faq</p>
                                </a> */}
                            </ul>
                        </div>
                        <div className="footer-icons text-center">
                            <a href="https://twitter.com/_TomCatJr_" target="_blank" >
                                <img className="mr-3 discord" src={twitter}></img>
                            </a>
                            <a href="https://discord.gg/2kQ94Nt5p7" target="_blank" >
                                <img className="mr-3 discord" src={discord}></img>
                            </a>
                            <a href="https://www.instagram.com/dirtytacoandtequila/?hl=en" target="_blank" >
                                <img className="mr-3 discord" src={insta}></img>
                            </a>
                            <a href="https://opensea.io/collection/artaxianft" target="_blank" >
                                <img className="discord" src={opensea}></img>
                            </a>
                        </div>
                    </div>
                    <div className="col-md-3"></div>
                </div>
            </div>
        </div>
    )
}
export default Footer;